import { monthAbrToNumber } from './monthAbrToNumber';
import { IStringDate } from './types';

export const MMMyyyyToStringDate = (string: string): IStringDate => {
  const month = string.substring(0, 3);
  const year = string.substring(4, 8);
  return `${year}-${monthAbrToNumber(month)}-01`;
};
